// @ts-nocheck
import { rowsPerPageInit } from "../../utils/constants/paginationConstants";
import {
  CLEAR_APPROVED_EVENTS,
  FETCH_APPROVED_EVENTS_FAILURE,
  FETCH_APPROVED_EVENTS_REQUEST,
  FETCH_APPROVED_EVENTS_SUCCESS,
} from "../constants/approvedEvents";

const initialState = {
  approvedEvents: [],
  isLoading: true,
  searchString: "",
  filtersData: null,
  rowsPerPage: rowsPerPageInit,
  currentPage: 1,
  totalPages: null,
  searchBy: [],
};

const approvedEventsReducer = (state = initialState, action) => {
  switch (action?.type) {
    // get all approved events
    case FETCH_APPROVED_EVENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchString: action?.payload?.searchString,
        searchBy: action?.payload?.searchBy,
        rowsPerPage: action?.payload?.rowsPerPage,
        filtersDate: action?.payload?.filtersDate,
      };

    case FETCH_APPROVED_EVENTS_SUCCESS:
      return {
        ...state,
        approvedEvents: action?.payload?.events,
        currentPage: action?.payload?.currentPage,
        totalPages: action?.payload?.totalPages,
        isLoading: false,
      };

    case FETCH_APPROVED_EVENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // clear all approved events
    case CLEAR_APPROVED_EVENTS:
      return {
        ...initialState,
      };

    // default case
    default:
      return state;
  }
};

export default approvedEventsReducer;
export { initialState };